
import React from 'react'
import tennisBallLoder from '../../../assets/images/tennis-ball_12128436.png'
import racketLoder from '../../../assets/images/loaderracket.png'
import styles from './CustomContainerLoader.module.css'
import iceSkatingImg from '../../../assets/images/ice-skate.gif'
import badmintonImg from '../../../assets/images/badminton.gif'
import { useSelector } from 'react-redux'

const CustomContainerLoader = () => {
    const selectedClub = useSelector((store) => store.user.selectedClub);
    return (
        <div className={styles['loader_container']}>
            {!selectedClub?.games && <>
                <div className={styles['loader_body']}>
                    <img className={styles['loader_ball']} src={tennisBallLoder} alt="" />
                    <img className={styles['loader_bat']} src={racketLoder} alt="" />
                </div>
                <span className={styles['loader_new']}></span>
            </>}
            {selectedClub?.games && selectedClub?.games[0]?.gameName?.toLowerCase() === 'pickleball' && <>
                <div className={styles['loader_body']}>
                    <img className={styles['loader_ball']} src={tennisBallLoder} alt="" />
                    <img className={styles['loader_bat']} src={racketLoder} alt="" />
                </div>
                <span className={styles['loader_new']}></span>
            </>}
            {selectedClub?.games && selectedClub?.games[0]?.gameName?.toLowerCase() === 'speedskating' &&
                <img className='loader_ice_skating' src={iceSkatingImg} alt="" />
            }
            {selectedClub?.games && selectedClub?.games[0]?.gameName?.toLowerCase() === 'badminton' &&
                <img className='loader_badminton' src={badmintonImg} alt="" />
            }
        </div>

    )
}

export default CustomContainerLoader
